module.exports = __webpack_public_path__ + "static/media/logo.5fd45946.png";